import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import FullCalendar from 'vue-full-calendar'
import BootstrapVue from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Typography from 'typography'
import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'
import VueSessionStorage from 'vue-sessionstorage'

import 'fullcalendar/dist/fullcalendar.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const typography = new Typography({
  baseFontSize: '16px',
  baseLineHeight: 1.3,
  headerFontFamily: [
    'Quicksand'
  ],
  bodyFontFamily: [
    'Quicksand'
  ]
})

typography.injectStyles()

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.use(VueSessionStorage)
Vue.use(FullCalendar)
Vue.use(BootstrapVue)
Vue.use(VueAnalytics, {
  id: 'UA-146990919-2',
  router,
  disabled: () => window.localStorage.getItem('cookies_disabled') !== null ? window.localStorage.getItem('cookies_disabled') === 'true' : true
})

library.add(faCoffee)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
